import * as utils from '../utils';

export default async (cardUuid: string): Promise<utils.IProviderResponse<Record<string, any>>> => {
  const url = `${process.env.REACT_APP_REST_API_ADDRESS}/api/v1/mobigrams/${cardUuid}/redeem_gift_card`;

  const response = await fetch(url, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json());

  if (response?.error) {
    return utils.ResponseError(response?.error);
  }

  const result = {
    link: response.gift_card_shortlink,
  };

  return utils.ResponseData(result);
};
